export const userType ={
    FETCH_USER_PROFILE:"FETCH_USER_PROFILE"
} 